export default "__VITE_ASSET__CEG0tymZ__"